export default "__VITE_ASSET__RWr3KTe7__"